import { FC } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { PrivateRoutes } from './PrivateRoutes';
import { ErrorsPage } from '../modules/errors/ErrorsPage';
import { Logout, AuthPage } from '../modules/auth';
import { App } from '../App';
import IdpLogin from "../pages/AuthIDP";
import Authinvitation from "../pages/Authinvitation";
import RedirectingPage from './RedirectingPage';

const AppRoutes: FC = () => {
  return (
    <Routes>
      <Route element={<App />}>
        <Route path="error/*" element={<ErrorsPage />} />
        <Route path="logout" element={<Logout />} />
        <Route path="IdpLogin" element={<IdpLogin />} />
        <Route path="invitation" element={<Authinvitation />} />
        
        {/* Nueva ruta de redirección para manejar la autenticación y el perfil */}
        <Route path="/redirecting" element={<RedirectingPage />} />

        {/* Rutas protegidas */}
        <Route path="/*" element={<PrivateRoutes />} />
        <Route path="auth/*" element={<AuthPage />} />
        <Route path="*" element={<Navigate to="/auth" />} />
      </Route>
    </Routes>
  );
};

export { AppRoutes };